/**
 * The type of payment being executed.
 */
export enum PaymentSourceType {
  /**
   * The user is paying for a set of documents/invoices.
   */
  PayOnInvoice = 'PayOnInvoice',

  /**
   * The user is making a general payment on their account balance.
   */
  PayOnAccount = 'PayOnAccount',

  /**
   * The user is paying an inputed lump sum to pay against their account balance.
   */
  PayOtherAmount = 'PayOtherAmount',

  /**
   * The user is paying using a payment link
   */
  PoieBiscuit = 'POE-BISCUIT',

  /**
   * The user is paying using a hosted payment link
   */
  HostedPaymentsPage = 'HostedPaymentsPage',
}
